import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Paper,
  Button,
  Collapse,
  IconButton
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ModalTableOfEmployees from './ModalTableOfEmployees';
import i18n from '../../i18n';
import '../../assets/stylesheets/ScheduleView.css';

class SendConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  generateAdditionalDetails = () => {
    const { expandView } = this.state;
    const { confirmationModalData } = this.props;
    const {
      fullTimeEmployees,
      unconfirmedEmployees,
      confirmedEmployees,
      unbookedEmployees,
      canceledEmployees,
      declinedEmployees,
      expiredBookingEmployees,
    } = confirmationModalData;

    if (
      fullTimeEmployees.length === 0 &&
      unconfirmedEmployees.length === 0 &&
      confirmedEmployees.length === 0 &&
      unbookedEmployees.length === 0 &&
      canceledEmployees.length === 0 &&
      declinedEmployees.length === 0 &&
      expiredBookingEmployees.length === 0
    ) {
      // No additional details to show
      return;
    }

    // eslint-disable-next-line consistent-return
    return (
      <>
        <div className="showDetailsLabel">
          {i18n.t('schedule:showAdditionalDetails')}
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMoreIcon color="secondary" />
          </IconButton>
        </div>

        <Collapse
          in={expandView}
          timeout="auto"
          className="showDetailsContainer"
        >
          {expiredBookingEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='pastBooking'
                employees={expiredBookingEmployees}
                rowStyle='dateExpired'
              />
              <br />
            </>
          ) : null}
          {fullTimeEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendFullTimeConfirmationEmails'
                employees={fullTimeEmployees}
              />
              <br />
            </>
          ) : null}
          {unconfirmedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendUnconfirmedConfirmationEmails'
                employees={unconfirmedEmployees}
                rowStyle='emailSent'
              />
              <br />
            </>
          ) : null}
          {confirmedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendConfirmedConfirmationEmails'
                employees={confirmedEmployees}
                rowStyle='emailConfirmed'
              />
              <br />
            </>
          ) : null}
          {unbookedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendUnbookedConfirmationEmails'
                employees={unbookedEmployees}
                rowStyle='unbookedFreelancer'
              />
              <br />
            </>
          ) : null}
          {canceledEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendCanceledConfirmationEmails'
                employees={canceledEmployees}
                rowStyle='canceled'
              />
              <br />
            </>
          ) : null}
          {declinedEmployees.length !== 0 ? (
            <>
              <ModalTableOfEmployees
                label='sendDeclinedConfirmationEmails'
                employees={declinedEmployees}
                rowStyle='declined'
              />
              <br />
            </>
          ) : null}
        </Collapse>
      </>
    );
  };

  render() {
    const {
      showModal,
      onCloseConfirmationModal,
      onClickSendEmails,
      confirmationModalData
    } = this.props;
    return (
      <Modal open={showModal} onClose={onCloseConfirmationModal}>
        <Paper className="validationModal">
          <h2>{i18n.t('schedule:sendConfirmationEmail')}</h2>
          <hr />

          {confirmationModalData.emailNotSentEmployees?.length ? (
            <>
              <ModalTableOfEmployees
                label='sendFreelancerConfirmationEmails'
                employees={confirmationModalData.emailNotSentEmployees}
              />
            </>
          ) : (
            <p>{i18n.t('schedule:noEmployeesToSendEmail')}</p>
          )}
          
          {this.generateAdditionalDetails()}

          <div className="blockHeader">
            {confirmationModalData.emailNotSentEmployees.length !== 0 && (
              <Button
                variant="contained"
                className="ssenseButton ssensePrimary"
                onClick={onClickSendEmails}
              >
                {i18n.t('schedule:sendEmails')}
              </Button>
            )}
            <Button
              variant="contained"
              className="ssenseButton ssenseDefault"
              onClick={onCloseConfirmationModal}
            >
              {i18n.t('cancel')}
            </Button>
          </div>
        </Paper>
      </Modal>
    );
  }
}

SendConfirmationModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseConfirmationModal: PropTypes.func.isRequired,
  onClickSendEmails: PropTypes.func.isRequired,
  confirmationModalData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};

export default SendConfirmationModal;
